export enum LinkDetectedDevice {
  user = 'user',
  card = 'card',
  beacon = 'beacon',
}
